
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";


export default function ArtistCard(props) {
  const [data, setData] = useState()
  useEffect(() => {
    setData(props?.data)
  }, [props?.data])

  return (
    <Link className="text-decoration-none" to={`/view-profile/artist/${data?._id}`} state={{ data }}>

      <div className="TrandingArtistMaineBox">
        <div className="imgBox">
          <div className="imginn">

            <img
            className="img-fluid"
           
            src={data?.bannerImage?.link || "images/newpng/newback.png"}
            alt=""
            />
          </div>
          <div className="meusimphoto">
            <img
              className="img-fluid"
              src={data?.profileImage?.link}
              alt=""
            /></div>
        </div>
        <div className="contBox">
          <div className="arthead mb-2">
            <h2 className="productName">{data?.name}</h2>
          </div>
          <p>{data?.description ? data?.description : 'N/A'}</p>
        </div>

      </div>
    </Link>
  );
}
